// Routes where the quick-actions rail starts collapsed to its edge tab (the existing swipe-hidden
// state) and the first-use callout is not shown. Safety pages carry crisis lines and safeword
// controls; an expanded fixed bottom-right tray covers them at 375px. Matches the base path and
// every sub-path:
//   /safeword, /safeword/aftercare/:logId
//   /safety, /safety/check-in, /safety/check-in/:checkinId, /safety/checkin-buddies
const QUICK_ACTIONS_COLLAPSED_PREFIXES = ['/safeword', '/safety'] as const;

export function isQuickActionsCollapsedRoute(pathname: string): boolean {
  const path = pathname.toLowerCase();
  return QUICK_ACTIONS_COLLAPSED_PREFIXES.some(
    prefix => path === prefix || path.startsWith(`${prefix}/`)
  );
}
